import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SwStatus = "activating" | "installed";

export interface OfflineStateType {
  swStatus: SwStatus;
  online: boolean;
}

const initialState: OfflineStateType = {
  swStatus: "activating",
  online: navigator.onLine
};

const offline = createSlice({
  name: "offline",
  initialState,
  reducers: {
    setOnline(state, { payload: online }: PayloadAction<boolean>) {
      state.online = online;
    },
    setSwStatus(state, { payload: swStatus }: PayloadAction<SwStatus>) {
      state.swStatus = swStatus;
    }
  }
});

export const { reducer, actions } = offline;
